module.exports = __webpack_public_path__ + "static/media/10.192bbbec.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row5/10.wav
// module id = 94
// module chunks = 0